<template>
  <div class="write-form">
    <div class="add-file">
      <input type="file" id="files" ref="files" multiple @change="handleFilesUpload" />
      <v-icon class="pl-2">attach_file</v-icon>
    </div>

    <input v-model="messageText" type="text" placeholder="Ваше сообщение..." @keyup.enter="sendMessage" />

    <!--<button @click="sendMessage" class="send">Отправить</button>-->
    <v-icon color="primary" class="pos-absolute img_send" @click="sendMessage"> send </v-icon>
  </div>
</template>

<script>
export default {
  props: {
    employerData: Object,
  },
  data() {
    return {
      messageText: '',
      files: null,
    }
  },
  methods: {
    sendMessage() {
      if (this.messageText !== '' || this.files !== null) {
        this.$emit('messagesent', {
          message: this.messageText,
          employer: this.employerData,
          attachments: this.files,
        })
      }
      this.messageText = ''
      this.files = null
    },
    handleFilesUpload() {
      this.files = this.$refs.files.files
    },
  },
}
</script>
